import React from 'react'

import { Tooltip } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { Link, Toolbar, useTranslate } from 'react-admin'

import {
  ADVANCE_LIST_STEP,
  INVOICE_FORM_STEP,
  FILE_UPLOAD_STEP,
} from './createDialogConstants'
import useStyles from './styles'

export const CreateInvoiceDialogToolbar = ({
  hasNextStep,
  hasPreviousStep,
  onNextClick,
  onPreviousClick,
  invalid,
  handleCancel,
  handleClose,
  handleBack,
  handleNext,
  handleAdd,
  handleSave,
  handleApply,
  stepNumber,
  isFinished,
  errorSave,
  basePath,
  savedFiles,
  invoiceList,
  saving,
  waitForPolling,
  ...props
}) => {
  const classes = useStyles()
  const translate = useTranslate()

  return (
    <Toolbar
      {...props}
      className={
        stepNumber === ADVANCE_LIST_STEP && isFinished && !errorSave
          ? classes.toolbarRight
          : classes.toolbarSpaceBetween
      }
    >
      {!props}

      {stepNumber === ADVANCE_LIST_STEP && (!isFinished || errorSave) && (
        <Link className={saving ? classes.linkDisabled : classes.link}>
          <Button
            className={
              saving
                ? classes.secondaryButtonNoBorderDisabled
                : classes.secondaryButtonNoBorder
            }
            onClick={(props) => {
              handleCancel(props)
            }}
            disabled={saving}
          >
            {translate('resources.invoices.actions.create.discard')}
          </Button>
        </Link>
      )}

      {stepNumber === INVOICE_FORM_STEP && (
        <Link className={classes.link}>
          <Button
            className={classes.secondaryButton}
            onClick={(props) => {
              handleCancel(props)
            }}
          >
            {translate('resources.invoices.actions.create.cancel')}
          </Button>
        </Link>
      )}

      {stepNumber === FILE_UPLOAD_STEP && (
        <div className={classes.link}>
          <Button
            className={classes.secondaryButton}
            onClick={(props) => {
              handleCancel(props)
            }}
          >
            {translate('resources.invoices.actions.create.cancel')}
          </Button>
        </div>
      )}

      {hasNextStep && stepNumber === INVOICE_FORM_STEP && (
        <Button
          className={invalid ? classes.buttonDisabled : classes.button}
          icon={<></>}
          disabled={invalid}
          onClick={(props) => {
            handleNext(props)
            onNextClick(props)
          }}
        >
          {translate('resources.invoices.actions.create.next')}
        </Button>
      )}

      {stepNumber === FILE_UPLOAD_STEP && (
        <div className={classes.toolbarRight}>
          <Link className={classes.link}>
            <Button
              className={classes.secondaryButtonNoBorder}
              onClick={(props) => {
                handleBack(props)
                onPreviousClick(props)
              }}
            >
              {translate('resources.invoices.actions.create.back')}
            </Button>
          </Link>
          <Button
            className={
              !savedFiles.length ? classes.buttonDisabled : classes.button
            }
            icon={<></>}
            disabled={!savedFiles.length}
            onClick={(props) => {
              handleApply(props)
            }}
          >
            {translate('resources.invoices.actions.create.next')}
          </Button>
        </div>
      )}

      {stepNumber === ADVANCE_LIST_STEP && (!isFinished || errorSave) && (
        <div className={classes.toolbarRight}>
          <div className={saving ? classes.linkDisabled : classes.link}>
            <Button
              className={
                saving
                  ? classes.secondaryButtonDisabled
                  : classes.secondaryButton
              }
              onClick={(props) => {
                handleAdd(props)
              }}
              disabled={saving}
            >
              {translate('resources.invoices.actions.create.add')}
            </Button>
          </div>
          <Tooltip
            className={!isFinished || errorSave ? undefined : classes.invisible}
            title={translate('resources.invoices.actions.create.submitTooltip')}
          >
            <span>
              <Button
                className={
                  invoiceList.length === 0 || saving
                    ? classes.buttonDisabled
                    : classes.button
                }
                disabled={invoiceList.length === 0 || saving}
                onClick={handleSave}
                icon={<></>}
              >
                {translate('resources.invoices.actions.create.submit')}
              </Button>
            </span>
          </Tooltip>
        </div>
      )}

      {stepNumber === ADVANCE_LIST_STEP && isFinished && !errorSave && (
        // <Link
        //   to={basePath}
        //   className={classes.link}

        // >
        <Button
          // className={classes.buttonClose}
          className={waitForPolling ? classes.buttonDisabled : classes.button}
          onClick={(props) => {
            handleClose(props)
          }}
          disabled={waitForPolling}
        >
          {translate('resources.invoices.actions.create.close')}
        </Button>
        // </Link>
      )}
    </Toolbar>
  )
}
